import { CreateRoomStep } from "./createRoom.types";

// Must match PREDEFINED_MEETING_NAMES[0] in ./ui/CreateRoomView.shared.
const CUSTOM_MEETING_NAME_OPTION = "Custom / Make your own...";

export interface CanProceedState {
  selectedMeetingNameOption: string;
  roomName: string;
  selectedHour: string;
  selectedMinute: string;
  selectedAmPm: string;
  selectedTopicIds: string[];
}

/**
 * Whether the "Create a conversation" wizard may advance from `step`.
 *
 * Step 2 (Basic Information) hosts both the name field and the date/time
 * picker, so it must require a fully-selected time slot — not just a valid
 * name. Otherwise a user can pick a date with no available slots (time stays
 * empty) and advance to Confirm, which then silently fails on web because the
 * time parameter is missing. (#95)
 */
export function canProceedCreateRoom(
  step: CreateRoomStep,
  state: CanProceedState,
): boolean {
  if (step === 1) return true;
  if (step === 2) {
    const nameValid =
      state.selectedMeetingNameOption !== CUSTOM_MEETING_NAME_OPTION ||
      state.roomName.trim().length > 0;
    const timeSelected =
      state.selectedHour.length > 0 &&
      state.selectedMinute.length > 0 &&
      state.selectedAmPm.length > 0;
    return nameValid && timeSelected;
  }
  if (step === 3) return state.selectedTopicIds.length > 0;
  return false;
}
